import React, { useEffect } from "react";

import { Spinner } from "react-bootstrap";

import { S3_URL } from "common/constants/apiUrls";
import { useTranslation } from "react-i18next";
import TextField from "common/TextField";
const Step4 = ({
  formik,
  productList = [],
  loading,
  handleBack,
  handleError,
  handleCompletion,
}) => {
  const { t } = useTranslation();
  const STEP_ID = 4;
  useEffect(() => {
    handleError(STEP_ID, false);
    handleCompletion(STEP_ID, true);
  }, []);
  return (
    <div className="d-flex flex-column justify-content-between h-100">
      <p className="mt-3">{t("product-access-text")}</p>
      <div className="inputField mt-2">
        <label style={{ margin: "0 0.4rem" }}>
          {" "}
          {t("enable-credit-card")}{" "}
          <input
            name="creditEnabled"
            type="checkbox"
            checked={formik?.values?.creditEnabled}
            onChange={formik?.handleChange}
          />
        </label>
        <TextField
          type="text"
          className="form-control"
          placeholder={t("credit-entity-id")}
          name="creditEntityId"
          isDisabled={!formik?.values?.creditEnabled}
        />
      </div>
      <div className="inputField mt-2">
        <label style={{ margin: "0 0.4rem" }}>
          {" "}
          {t("enable-sepa")}{" "}
          <input
            name="sepaEnabled"
            type="checkbox"
            onChange={formik?.handleChange}
            checked={formik?.values?.sepaEnabled}
          />
        </label>
        <TextField
          type="text"
          className="form-control"
          placeholder={t("sepa-entity-id")}
          name="sepaEntityId"
          isDisabled={!formik?.values?.sepaEnabled}
        />
      </div>
      <div className="inputField mt-2">
        <label style={{ margin: "0 0.4rem" }}>{t("access-token")}</label>
        <TextField
          type="text"
          className="form-control"
          placeholder={t("access-token")}
          name="accessToken"
          isDisabled={
            !(formik?.values?.creditEnabled || formik?.values?.sepaEnabled)
          }
        />
      </div>
      <div className="inputField mt-2">
        <label style={{ margin: "0 0.4rem" }}>{t("subscription-price")}</label>
        <TextField
          type="number"
          className="form-control"
          placeholder={t("subscription-price")}
          name="subscriptionPrice"
          isDisabled={
            !(formik?.values?.creditEnabled || formik?.values?.sepaEnabled)
          }
        />
      </div>

      <div className="d-flex justify-content-end align-items-center mt-5">
        <button
          className="parentbtn"
          style={{
            padding: "10px 35px",
            marginRight: "15px",
            backgroundColor: "gray",
          }}
          onClick={handleBack}
        >
          {t("back")}
        </button>
        <button
          type="submit"
          className="parentbtn "
          style={{ padding: "10px 35px" }}
        >
          {loading ? <Spinner animation="border" size="sm" /> : t("add-branch")}
        </button>
      </div>
    </div>
  );
};

export default Step4;
